import { existsOperator } from "views/components/searchbar/completions/FieldNameCompletion";
export const removeFinalColon = (tokenValue) => tokenValue.slice(0, -1);
export const isTypeTerm = (token) => !!(token && token.type === "term");
export const isTypeString = (token) => (token == null ? void 0 : token.type) === "string";
export const isTypeText = (token) => (token == null ? void 0 : token.type) === "text";
export const isTypeNumber = (token) => (token == null ? void 0 : token.type) === "constant.numeric";
export const isTypeKeyword = (token) => (token == null ? void 0 : token.type) === "keyword";
export const isKeywordOperator = (token) => (token == null ? void 0 : token.type) === "keyword.operator";
export const isExistsOperator = (token) => isTypeKeyword(token) && token.value === `${existsOperator.name}:`;
export const isCompleteFieldName = (token) => !!(isTypeKeyword(token) && (token == null ? void 0 : token.value.endsWith(":")));
export const isSpace = (token) => isTypeText(token) && (token == null ? void 0 : token.value) === " ";
export const isLeftParen = (token) => (token == null ? void 0 : token.type) === "paren.lparen";
export const isRightParen = (token) => (token == null ? void 0 : token.type) === "paren.rparen";
export const getFieldNameForFieldValueInBrackets = (tokens, currentTokenIndex) => {
  var _a;
  if (!(tokens == null ? void 0 : tokens.length)) {
    return null;
  }
  const currentToken = tokens[currentTokenIndex];
  const prevToken = (_a = tokens[currentTokenIndex - 1]) != null ? _a : null;
  if ((prevToken == null ? void 0 : prevToken.type) === "keyword" && (prevToken == null ? void 0 : prevToken.value.endsWith(":")) && isLeftParen(currentToken)) {
    return removeFinalColon(prevToken.value);
  }
  let fieldNameIndex = null;
  let openingBracketsCount = 0;
  let closingBracketsCount = 0;
  for (let i = 0; i < currentTokenIndex; i += 1) {
    if (tokens[i].type === "keyword" && tokens[i].value.endsWith(":") && isLeftParen(tokens[i + 1])) {
      fieldNameIndex = i;
    }
    if (fieldNameIndex !== null && isLeftParen(tokens[i])) {
      openingBracketsCount += 1;
    }
    if (fieldNameIndex !== null && isRightParen(tokens[i])) {
      closingBracketsCount += 1;
    }
    if (openingBracketsCount && closingBracketsCount && openingBracketsCount === closingBracketsCount) {
      openingBracketsCount = 0;
      closingBracketsCount = 0;
      fieldNameIndex = null;
    }
  }
  if (fieldNameIndex !== null) {
    return removeFinalColon(tokens[fieldNameIndex].value);
  }
  return null;
};
